

// import React, { useState } from "react";
// import AttendanceUpload from "./AttendanceUpload";
// import AttendanceReport from "./AttendanceReport";
// import AttendanceRuleInfractions from "./AttendanceRuleInfractions";
// import "../styles/AttendanceTracker.css";

// function AttendanceTracker() {
//   const [activeTab, setActiveTab] = useState("upload");
//   const [uploaded, setUploaded] = useState(false);

//   const handleUploadSuccess = () => {
//     setUploaded(true);
//     setActiveTab("report"); // auto switch
//   };

//   const handleExportReport = () => {
//     window.open("/gt-api/export_attendance_report.php");
//   };

//   return (
//     <div className="attendance-page">

//       <h2 className="attendance-heading">Attendance Tracker</h2>

//       {/* 🔷 TABS */}
//       <div className="tabs">
//         <button
//           className={activeTab === "upload" ? "active" : ""}
//           onClick={() => setActiveTab("upload")}
//         >
//           📂 Upload
//         </button>

//         <button
//           className={activeTab === "report" ? "active" : ""}
//           onClick={() => setActiveTab("report")}
//           disabled={!uploaded}
//         >
//           📊 Report
//         </button>

//         <button
//           className={activeTab === "rule-infractions" ? "active" : ""}
//           onClick={() => setActiveTab("rule-infractions")}
//           disabled={!uploaded}
//         >
//           ⚠️ Rule Infractions
//         </button>

//         <button onClick={handleExportReport}>
//           Export Full Report
//         </button>
//       </div>

//       {/* 🔲 CONTENT */}
//       <div className="tab-content">

//         {activeTab === "upload" && (
//           <AttendanceUpload onUploadSuccess={handleUploadSuccess} />
//         )}

//         {activeTab === "report" && (
//           !uploaded ? (
//             <div className="empty-state">
//               Upload file first to view report 📂
//             </div>
//           ) : (
//             <AttendanceReport />
//           )
//         )}

//         {activeTab === "rule-infractions" && (
//           !uploaded ? (
//             <div className="empty-state">
//               Upload file first to view rule infractions 📂
//             </div>
//           ) : (
//             <AttendanceRuleInfractions />
//           )
//         )}

//       </div>

//     </div>
//   );
// }

// export default AttendanceTracker;
















import React, { useState, useEffect } from "react";
import { UploadCloud, FileBarChart, AlertTriangle, Download, Sparkles, FolderUp } from "lucide-react";
import AttendanceUpload from "./AttendanceUpload";
import AttendanceReport from "./AttendanceReport";
import AttendanceRuleInfractions from "./AttendanceRuleInfractions";
import "../styles/AttendanceTracker.css";

function AttendanceTracker() {
  const [activeTab, setActiveTab] = useState("upload");
  const [uploaded, setUploaded] = useState(false);
  const [reportMonth, setReportMonth] = useState("");

  useEffect(() => {
    fetch("/gt-api/get_department_analytics.php")
      .then((res) => res.json())
      .then((data) => {
        if (data && data.report_month) {
          setReportMonth(data.report_month.replace("-", " "));
        }
      })
      .catch(() => {});
  }, []);

  const handleUploadSuccess = () => {
    setUploaded(true);
    setActiveTab("report"); // auto switch
  };

  const handleExportReport = () => {
    window.open("/gt-api/export_attendance_report.php");
  };

  return (
    <div className="attendance-page">
      {/* 🌟 SLEEK HEADER */}
      <div className="attendance-header-banner">
        <div className="attendance-header-title-box">
          <div className="attendance-header-icon-ring">
            <Sparkles className="attendance-header-sparkle-icon" size={22} />
          </div>
          <div>
            <h2 className="attendance-heading">Attendance Tracker</h2>
            <p className="attendance-subheading">
              Manage logs, review monthly employee attendance reports, and track rule infractions seamlessly
            </p>
          </div>
        </div>

        {/* EXPORT BUTTON IN HEADER / ACTION BAR */}
        <button className="export-report-btn" onClick={handleExportReport}>
          <Download size={16} />
          <span>Export Full Report</span>
        </button>
      </div>

      {/* 🔷 TABS NAVIGATION */}
      <div className="tabs-container">
        <div className="tabs">
          <button
            className={`tab-btn ${activeTab === "upload" ? "active" : ""}`}
            onClick={() => setActiveTab("upload")}
          >
            <UploadCloud size={17} />
            <span>Upload File</span>
          </button>

          <button
            className={`tab-btn ${activeTab === "report" ? "active" : ""}`}
            onClick={() => setActiveTab("report")}
            disabled={!uploaded}
            title={!uploaded ? "Please upload an attendance file first" : ""}
          >
            <FileBarChart size={17} />
            <span>Attendance Report</span>
            {uploaded && <span className="tab-badge-ready">{reportMonth || "Ready"}</span>}
          </button>

          <button
            className={`tab-btn ${activeTab === "rule-infractions" ? "active" : ""}`}
            onClick={() => setActiveTab("rule-infractions")}
            disabled={!uploaded}
            title={!uploaded ? "Please upload an attendance file first" : ""}
          >
            <AlertTriangle size={17} />
            <span>Rule Infractions</span>
          </button>
        </div>
      </div>

      {/* 🔲 TAB CONTENT AREA */}
      <div className="tab-content">
        {activeTab === "upload" && (
          <AttendanceUpload onUploadSuccess={handleUploadSuccess} />
        )}

        {activeTab === "report" && (
          !uploaded ? (
            <div className="empty-state">
              <div className="empty-state-icon-box">
                <FolderUp size={36} color="#6366f1" />
              </div>
              <h3>No Attendance File Uploaded Yet</h3>
              <p>Upload a punch log file in the Upload tab to generate the monthly attendance report.</p>
              <button 
                className="empty-state-action-btn"
                onClick={() => setActiveTab("upload")}
              >
                <UploadCloud size={16} /> Go to Upload
              </button>
            </div>
          ) : (
            <AttendanceReport />
          )
        )}

        {activeTab === "rule-infractions" && (
          !uploaded ? (
            <div className="empty-state">
              <div className="empty-state-icon-box">
                <AlertTriangle size={36} color="#f59e0b" />
              </div>
              <h3>Rule Infractions Unavailable</h3>
              <p>Please upload an attendance file first to analyze break time limits and late entries.</p>
              <button 
                className="empty-state-action-btn"
                onClick={() => setActiveTab("upload")}
              >
                <UploadCloud size={16} /> Go to Upload
              </button>
            </div>
          ) : (
            <AttendanceRuleInfractions />
          )
        )}
      </div>
    </div>
  );
}

export default AttendanceTracker;

